import { createAction, props, union } from '@ngrx/store';
import {
  RetrieveAuthorizationVerbiageResponseV1,
  SerializableMap,
  TransactionAuthorizationResult,
} from '@arc/unified-payments-frontend/shared-payment';

export const bankAuthorizationVerbiageUpdated = createAction(
  '[POA Payment - Review Payment] Bank Authorization Verbiage Updated',
  props<{
    payload: RetrieveAuthorizationVerbiageResponseV1;
  }>(),
);

export const paymentExecuted = createAction(
  '[POA Payment - Review Payment] Payment Executed',
  props<{
    transactionResults: SerializableMap<TransactionAuthorizationResult>;
  }>(),
);

export const checkPaymentStatusCompleted = createAction(
  '[POA Payment - Review Payment] Check Payment Status Completed',
  props<{
    results: SerializableMap<TransactionAuthorizationResult>;
    checkStatusCount: number;
    checkStatusTimeout: boolean;
    authorizationPending: boolean;
  }>(),
);

export const checkPaymentStatusErrorAction = createAction(
  '[POA Payment - Review Payment] Check Payment Status Error',
);

export const checkPaymentStatusTimedOutAction = createAction(
  '[POA Payment - Review Payment] Check Payment Status Timed Out',
  props<{
    results: SerializableMap<TransactionAuthorizationResult>;
  }>(),
);

export const checkPaymentStatusCanceledAction = createAction(
  '[POA Payment - Review Payment] Check Payment Status Canceled',
);

const PoaBtPayReviewPaymentActions = union({
  bankAuthorizationVerbiageUpdated,
  paymentExecuted,
  checkPaymentStatusCompleted,
});

export type PoaBtPayReviewPaymentActionsUnion =
  typeof PoaBtPayReviewPaymentActions;
